import React, { Component } from 'react';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import './AttModal.css'

const defaultProps = {
    firstButtonModal: 'sim',
    secondButtonModal: 'não',
    showModal: true,
    message: 'Já passaram mais de 10 minutos desde a sua pesquisa. Deseja recarregar?'
};

const propTypes = {
    id: PropTypes.string.isRequired,
    firstOption: PropTypes.func,
    secondOption: PropTypes.func,
    showModal: PropTypes.bool.isRequired,
    header: PropTypes.string,
    message: PropTypes.any
};

class AttModal extends Component {
    render() {
        return (
            <Modal id={`modal-${this.props.id}`}
                show={this.props.showModal}
                onHide={this.props.firstOption}>
                {this.props.header ? (
                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.header}</Modal.Title>
                    </Modal.Header>
                ) : null}
                <Modal.Body bsClass="modal-att-body">
                    <Row>
                        <Col sm={12} xs={12} md={12} lg={12} className="modal-att-body-content">
                            <div className="modal-att-icon" />
                        </Col>
                    </Row>
                    <Row>
                        <Col
                            id={`modal-${this.props.id}-message`}
                            sm={12}
                            xs={12}
                            md={12}
                            lg={12}
                            className="modal-att-body-content">
                            {this.props.message}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer bsClass="modal-att-footer">
                    <Row>
                        <Col sm={12} xs={12} md={12} lg={12}>
                            <Button
                                bsClass="modal-att-button"
                                id={`btn-modal-${this.props.id}`}
                                onClick={this.props.firstOption}
                                ref={f => (this.firstOption = f)}>
                                {this.props.firstButtonModal}
                            </Button>
                            <Button
                                bsClass="modal-att-button"
                                id={`btn-modal-${this.props.id}`}
                                onClick={this.props.secondOption}
                                ref={s => (this.secondOption = s)}>
                                {this.props.secondButtonModal}
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        );
    }
}

AttModal.defaultProps = defaultProps;
AttModal.propTypes = propTypes;

export default AttModal;



// WEBPACK FOOTER //
// ./src/components/common/attPageModal/AttModal.jsx